<template>
    <div>
        <!-- dialog transaction-->
        <v-dialog v-model="dialog" persistent @keydown.esc="dialog = false" width="850">
            <v-card>
                <div class="d-flex primary py-1">
                    <v-card-title
                        class="text-uppercase flex-grow-1 text-subtitle-1 justify-center pa-0 white--text"
                    >
                        Material transportation
                    </v-card-title>

                    <!-- close button -->
                    <v-btn icon @click="dialog = false" :disabled="loading || submitLoading">
                        <v-icon color="white">
                            mdi-close-circle-outline
                        </v-icon>
                    </v-btn>
                </div>

                <v-card-text class="mt-2">
                    <bee-handy-smart-table
                        v-model="tableInputs"
                        ref="table"
                        :items="transactionEmployeeTeam"
                        :headers="headers"
                        zebra
                        dense
                        hide-default-footer
                        :items-per-page="-1"
                        :loading="submitLoading || loading || loadingTest"
                        pagination-on-scroll
                        :show-add-row="false"
                        :editable-rows="!loading"
                        :row-highlight-expression="item => item.isDone"
                        row-highlight-expression-class="lightGreenLighten"
                        height="400px"
                        :shown-rows-text="$t('shown-rows')"
                    >
                        <template v-slot:input.accountId="{ attr, on }">
                            <v-autocomplete
                                :items="staff?.filter(c => c.id !== employeeId)"
                                item-value="accountId"
                                item-text="name"
                                v-on="on"
                                v-bind="attr"
                            ></v-autocomplete>
                        </template>

                        <!-- product name -->
                        <template v-slot:input.materialId="{ attr, on }">
                            <v-autocomplete
                                :items="myMaterials"
                                item-value="id"
                                :item-text="(item) =>`${item.remaining} - ${item.name} `"
                                v-bind="attr"
                                v-on="on"
                            ></v-autocomplete>
                        </template>
                        
                        <!-- <template v-slot:input.date="{ on, attr }">
                            <v-menu
                                ref="dateInputTable"
                                v-model="dateInputTable"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="tableInputs.date"
                                        clearable
                                        type="date"
                                        v-on="on"
                                        v-bind="attr"
                                    >
                                        <template v-slot:prepend>
                                            <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                mdi-calendar
                                            </v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="tableInputs.date"
                                    :active-picker.sync="activePickerDate"
                                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                                    min="1940-01-01"
                                    :allowed-dates="disableDates"
                                    @change="saveDate"
                                ></v-date-picker>
                            </v-menu>
			            </template> -->

                        <template v-slot:no-input.actions>
                            <div class="d-flex justify-center">
                                <tooltip :text="$t('edit')" top>
                                    <v-btn
                                        v-if="isEdit"
                                        icon
                                        small
                                        color="success"
                                        @click="editItem()"
                                    >
                                        <v-icon>
                                            mdi-check-circle-outline
                                        </v-icon>
                                    </v-btn>
                                </tooltip>

                                <tooltip :text="$t('cancel')" top>
                                    <v-btn
                                        v-if="isEdit"
                                        icon
                                        small
                                        color="grey darken-2"
                                        @click="$refs.table.resetEdit()"
                                    >
                                        <v-icon>
                                            mdi-close-circle-outline
                                        </v-icon>
                                    </v-btn>
                                </tooltip>
                            </div>
                        </template>

                        <template v-slot:item.actions="{ item, index }">
                            <tooltip :text="$t('')">
                                <v-btn  
                                    color="orange"
                                    small
                                    icon
                                    @click="transactionAndPosted(item.id)"
                                    :disabled="submitLoading || item.isDone || loadingTest || loading || submitLoading"
                                >
                                    <v-icon>
                                        mdi-restore
                                    </v-icon>
                                </v-btn>
                            </tooltip>

                            <tooltip :text="$t('edit')" top>
                                <v-btn
                                    color="success"
                                    small
                                    icon
                                    @click="() => {
                                        $refs.table.activeEditForRow(index);
                                        editRowIndex = index;
                                        isEdit = true;
                                        $nextTick(() => {
                                            $refs.table.resetInputsFocus()
                                        });
                                        myItem = item
                                    }"
                                    :disabled="submitLoading || item.isDone || loadingTest || loading || submitLoading"
                                >
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </tooltip>

                            <tooltip :text="$t('delete')" top>
                                <v-btn
                                    color="alert-color"
                                    small
                                    icon
                                    @click="deleteDialogRow(item.id)"
                                    :disabled="submitLoading || item.isDone || loadingTest || loading || submitLoading"
                                >
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </tooltip>
                        </template>
                    </bee-handy-smart-table>
                </v-card-text>
                <v-loader v-if="loadingTest === true" />

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="grey darken-1"
                        text
                        @click="dialog = false"
                        :disabled="loading || submitLoading"
                    >
                        {{$t('close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- filter -->
        <v-row>
            <v-col cols="2" class="my-1">
                <v-autocomplete 
                    v-model="teamId"
                    :items="teams"
                    item-text="name"
                    item-value="id"
                    hide-details
                    dense
                    outlined
                    label="Team"
                    :disabled="loading"
                    :loading="loading"
                />
            </v-col>   

            <v-col cols="3">
                <bee-date-input
				    v-model="startDate"
				    :label="$t('inputs.date')"
				    :loading="loading"
                    :disabled="loading || submitLoading"
				dense
                hide-details
                input-format-order="year-month-day"
                input-type="month"
				:append-icon="$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left'"
				:prepend-icon="$i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right'"
                readonly
                fit-inputs
				@click:append="nextMonth()"
				@click:prepend="prevMonth()"
			></bee-date-input>
            </v-col>
           
            <!-- <v-col cols="6" sm="3" md="2" class="px-1">
                <bee-date-picker
                    v-model="startDate"
                    :input-label="$t('inputs.start-date')"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        outlined: true,
                        dense: true,
                        clearable: true
                    }"
                    :allowed-dates="disableDates"
                    years-over-max="3"
                    :loading="loading || submitLoading"
                    :disabled="submitLoading"
                ></bee-date-picker>
            </v-col>
            
            <v-col cols="6" sm="3" md="2" class="px-1">
                <bee-date-picker
                    v-model="endDate"
                    :input-label="$t('inputs.end-date')"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        outlined: true,
                        dense: true,
                        clearable: true
                    }"
                    :allowed-dates="disableDates"
                    years-over-max="3"
                    :loading="loading || submitLoading"
                    :disabled="submitLoading"
                ></bee-date-picker>
            </v-col>  -->

            <v-spacer />
            <v-col class="d-flex justify-end" align-self="center">
                <v-btn
                    color="success"
                    class="px-sm-4 mx-2"
                    :loading="loading"
                    :disabled="loading || !teamId"
                    small
                    @click="transactionEmployeeTeam = []; getTeamById()"
                >
                    <v-icon size="15" class="me-1"> mdi-magnify </v-icon>
                    {{$t('search')}}
                </v-btn>
                <v-btn
                    v-if="isPreview"
                    color="edit-color white--text"
                    class="px-sm-4 mx-2"
                    :loading="loading"
                    :disabled="loading || !teamId || submitLoading"
                    small
                    @click="isPreview = false"
                >
                    <v-icon size="15" class="me-1"> mdi-pencil </v-icon>
                    {{ $t('edit') }}
                </v-btn>
            </v-col>
        </v-row>
        <div>
            <v-progress-linear  v-if="loading" indeterminate />
            <v-card v-if="!loading">
                <v-card-text>
                    <v-form>                   
                        <v-row v-for="(row, index) in items" :key="index">
                            <v-col>
                                <v-autocomplete
                                    v-model="specialtyIds[index]"
                                    :items="specialtiesByTeam"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    :label="$t('inputs.specialty')"
                                    outlined
                                    hide-details
                                    :disabled="isPreview || submitLoading"
                                />
                            </v-col>
                            <v-col>
                                <v-autocomplete
                                    v-model="materialIds[index]"
                                    :items="materialsWithSpe.length
                                        ? materialsWithSpe.find(c => c.specialtyId == specialtyIds[index])?.materialIds.map(c => ({
                                            id: c,
                                            name: getMaterialById(c).name
                                        })) : []"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    label="Materials"
                                    outlined
                                    hide-details
                                    clearable
                                    :disabled="isPreview || submitLoading"
                                />
                            </v-col>

                            <v-col cols="2">
                                <v-autocomplete 
                                    v-model="workloadId[index]"
                                    :items="classification"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('inputs.class')"
                                    dense
                                    outlined
                                    hide-details
                                    clearable
                                    :disabled="isPreview || submitLoading"
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-text-field  
                                    v-model="quantity[index]"
                                    dense
                                    label="quantity"
                                    outlined
                                    multiple
                                    type="number"
                                    hide-details 
                                    :disabled="isPreview || submitLoading"
                                />
                            </v-col>
                            <v-col>
                                <v-text-field
                                    v-model="notes[index]"
                                    dense
                                    label="Notes"
                                    outlined
                                    multiple
                                    hide-details
                                    :disabled="isPreview || submitLoading"
                                />
                            </v-col>

                            <v-col class="d-flex justify-end">
                                <v-btn
                                    icon
                                    color="success"
                                    @click="addingRow(index)"
                                    :disabled="isPreview || submitLoading"
                                >
                                    <v-icon> mdi-plus-circle </v-icon>
                                </v-btn>

                                <v-btn 
                                    :disabled="submitLoading || Boolean(!materialIds[index]) || isPreview || !quantity[index]" 
                                    color="success white--text" 
                                    @click="row?.id ? update(index) : create(index)"
                                    icon
                                >
                                    <v-icon>mdi-check-circle</v-icon>
                                </v-btn>

                                <v-btn
                                    icon
                                    color="alert-color"
                                    @click="deletingRow(row.id)"
                                    :disabled="isPreview || submitLoading"
                                >
                                    <v-icon size=""> mdi-delete-circle </v-icon>
                                </v-btn>
                            </v-col>

                            <!-- <v-col 
                                cols="12" 
                                v-if="
                                    index > 0 && row.specialtyId !== sortedItems[index - 1].specialtyId 
                                    || index === 0 && row.specialtyId !== sortedItems[1].specialtyId
                                " 
                                class="d-flex" 
                            >
                                <v-divider
                                    :key="`divider-${index}`"
                                    class="my-4"
                                ></v-divider>

                                <v-btn
                                    icon
                                    color="success"
                                    @click="addingRow(index)"
                                    :disabled="isPreview || submitLoading"
                                >
                                    <v-icon> mdi-plus-circle </v-icon>
                                </v-btn>
                            </v-col> -->
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
            <div v-if="!isempty || !teamId" class="d-flex justify-space-between mt-2">
                <v-spacer />
                <v-btn
                    color="primary"
                    small
                    @click="submit"
                    :loading="submitLoading"
                    :disabled="loading || submitLoading"
                >
                    <v-icon small class="me-2"> mdi-content-save  </v-icon>
                    {{ $t('save')}} 
                </v-btn>
            </div>
        </div>

        <!-- <div
            v-else
            class="d-flex flex-column justify-center align-center"
            :style="{ height: `${$vuetify.breakpoint.height - 211}px`}"
        >
            <v-progress-circular
                v-if="loading"
                color="primary"
                indeterminate
                size="44"
                width="4"
            />
            <template v-else>
                <v-icon size="60" class="mb-1">mdi-invoice-list</v-icon>
                <span class="text-h6">{{$t('SpecialtyAndTeams.please-select-a-team')}}</span>
            </template>
        </div> -->
    </div>
</template>

<script>
import { contactInfoTypes } from '@/helpers/enums'
import { mapGetters, mapState } from 'vuex'
import { disableDates } from '@/helpers/functions'
import moment from 'moment'
import rules from '@/validation rules'
import Tooltip from '@/components/Tooltip.vue'

export default {
    components: {
        Tooltip
    },

    data() {
        return {
            tableInputs: {},
            items: [],
            submitLoading: false,
            loading: false,
            contactInfoTypes,
            teamId: null,
            materialsWithSpe: [],
            specialtyIds: [],
            materialIds: [],
            quantity: [],
            notes: [],
            workloadId: [],
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().endOf('month').format('YYYY-MM-DD'),
            specialtiesByTeam: [],
            isPreview: false,
            isSearch: false,
            rules,
            dialog: false,
            myItem: {},
            isEdit: false,
            editRowIndex: null,
            teamPlan: [],
            transactionEmployeeTeam: [],
            dateInputTable: false,
            activePickerDate: null,
            isAdd: [],
            isempty: false,
            loadingTest: true
        }
    },

    watch: {
        dateInputTable (val) {
            val && setTimeout(() => (this.activePickerDate))
        },
    },

    computed: {
        ...mapState({
            teams: state => state.teams.teams,
            specialties: state => state.specialties.specialties,
            materials: state => state.materials.materials,
            staff: state => state.accounts.staff,
            employeeId: state => state.auth.self.employeeId,
            myMaterials: state => state.materials.myMaterials,
            classification: state => state.workload.classification
        }),
        ...mapGetters({
            getMaterialById: 'materials/getMaterialById'
        }),
        headers () {
            return [ 
			    {
                    text: this.$t('headers.account'),
                    name: 'accountId',
                    value: 'accountId',
                    setValueExpr: val => this.staff.find(c => c.accountId === val)?.name,
                    type: 'string',
					sortable: false,
					cellClass: 'px-1',
                    disableInput: true
				},
                {
                    text: this.$t('headers.item'),
                    name: 'materialId',
                    value: 'materialId',
                    setValueExpr: val => this.myMaterials?.find(c => c.id === val)?.name,
                    type: 'string',
					sortable: false,
					cellClass: 'px-1',
                    disableInput: true
                },
                {
                    text: this.$t('headers.amount'),
                    name: 'in',
                    value: 'in',
					inputRules: this.isIntNumberRule ? rules.IntNumber : rules.requiredAsNumber,
                    type: 'number',
					sortable: false,
					cellClass: 'px-1',
                },
                {
                    text: this.$t('headers.notes'),
                    name: 'description',
                    value: 'description',
					setValueExpr: val => val ? val.includes('Transaction from visit') ? '- ' : val : '-',
                    type: 'string',
					sortable: false,
					width: this.entityTab !== 0 ? '20%' : '40%',
					cellClass: 'px-1',
                },
				{	
                    text: this.$t('headers.deliver-date'),
                    name: 'date',
                    value: 'date',
					type: 'date',
					sortable: false,
					cellClass: 'px-0',
                    disableInput: true
                },
				{
					text: '',
                    name: 'actions',
                    value: 'actions',
                    width: "auto",
                    noInput: true,
                    noNotAvailableText: true,
                    sortable: false,
					cellClass: 'px-1',
				}
            ]
        },

        sortedItems() {
            if (!this.items) return [];
            return [...this.items].sort((a, b) => {
                if (a.specialtyId < b.specialtyId) return -1;
                if (a.specialtyId > b.specialtyId) return 1;
                return 0;
            });
        }
    },

    methods: {
        moment,
        disableDates,
        addingRow(index) {
            this.items.splice(index + 1, 0, {
                name: this.items[index]?.name,
                specialtyId: this.items[index]?.specialtyId,
                materials: this.items[index]?.materialId,
                amount: 0,
                workloadId: null,
                notes: null
            })

            this.specialtyIds.splice(index + 1, 0,
                this.items[index]?.specialtyId,
            )

            this.materialIds.splice(index + 1, 0, this.items[index]?.materialId)
            this.quantity.splice(index + 1, 0, null)
            this.notes.splice(index + 1, 0, null)
            this.workloadId.splice(index + 1, 0, null)
            this.isAdd.splice(index + 1, 0, true)
        },

        deletingRow (id) {
            this.loading = true
            this.$store.dispatch('materials/deleteTeamSpecialtyMaterial', { id: id }).then(() => {
                this.getTeamById().then(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
            })
        },
        deleteRow({ index }) {
            this.items.splice(index, 1);
        },
        addNewRow({ index }) {
            this.items.splice(index, 0, {
                value: this.items[index]?.value
            })
        },

        getTeamById() {
            this.loading = true
            this.items = []
            this.specialtyIds = []
            this.specialtiesByTeam = []
            this.materialIds = []
			this.quantity = []
			this.notes = []
            this.workloadId = []
            this.isPreview = false

            const team = this.teams.find(c => c.id === this.teamId)
            this.isempty = false

            this.$store.dispatch('materials/fetchMaterialForSpecialties', { specialtyIds: team.specialtyIds }).then((data) => {
                // store materials with specialty
                this.materialsWithSpe = data
            }).then((data) => {
                // this.endpoint change when upload api
                this.$store.dispatch('materials/fetchMaterialsTeams', { 
                    teamId: this.teamId, 
                    fromDate: moment(this.startDate).format('YYYY-MM-DD'), 
                    toDate:  moment(moment(this.startDate).endOf('month')).format('YYYY-MM-DD') 
                }).then((data) => {
                    this.specialtiesByTeam = team.specialtyIds.map(c => ({
                        name: this.specialties.find(g => g.id === c).name,
                        id: c
                    }))
                    if (data.length > 0) {
						this.items = data.map(c => (c.teamSpecialtiesMaterials)).flat()

						for (let i = 0; i < this.items.length; i++){
							this.materialIds[i] = this.items[i].materialId
							this.specialtyIds[i] = this.items[i].specialtyId
							this.quantity[i] = this.items[i].amount   
							this.notes[i] = this.items[i].notes
                            this.workloadId[i] = this.items[i].workloadId
						}
						this.isPreview = true

                        for (let i = 0; i < this.items.length; i++) {
                            if (this.materialsWithSpe.filter(c => c.specialtyId === this.items[i].specialtyId).length !== 0) {
                                this.items[i].materials = this.materialsWithSpe.filter(c => c.specialtyId === this.items[i].specialtyId)[0].materialIds.map(c => ({
                                    id: c,
                                    name: this.materials.find(f => f.id === c)?.name
                                }))
                            } else {
                                this.items[i].materials = []
                            }
                        }
                    } else {
                        this.isempty = true
                        for (let i = 0; i < this.items.length; i++){
							this.materialIds[i] = null
							this.specialtyIds[i] = this.items[i].specialtyId
							this.quantity[i] = null   
							this.notes[i] = null
                            this.workloadId[i] = null
                            this.isAdd[i] = true  
						}

                        for (let i = 0; i < team.specialtyIds.length; i++) {
                            this.items.push({
                                specialtyId: team.specialtyIds[i],
                                name: this.specialties.find(c => c.id === team.specialtyIds[i])?.name
                            }) 
                        }
                        this.items.forEach((ele) => {
                            this.specialtyIds.push(ele.specialtyId)
                        })
                        for (let i = 0; i < this.items.length; i++) {
                            if (this.materialsWithSpe.filter(c => c.specialtyId === this.items[i].specialtyId).length !== 0) {
                                this.items[i].materials = this.materialsWithSpe.filter(c => c.specialtyId === this.items[i].specialtyId)[0].materialIds.map(c => ({
                                    id: c,
                                    name: this.materials.find(f => f.id === c)?.name
                                }))
                            } else {
                                this.items[i].materials = []
                            }
                        }
                    }
                }).catch(() => {
                    this.loading = false
                })
            }).finally(() => {
                this.loading = false              
            })
        },
        create (index) {
            this.submitLoading = true
            this.$store.dispatch('teams/createTeamMaterial', {
                teamId: this.teamId,
                specialtyId: this.specialtyIds[index],
                date: moment(this.startDate).format('YYYY-MM-DD'),
                material: {
                    materialId: this.materialIds[index],
                    amount: +this.quantity[index],
                    notes: this.notes[index],
                    workloadId: this.workloadId[index]
                }
            }).then(() => {
                this.getTeamById()
                // this.$store.dispatch('materials/fetchMaterialsTeams', { teamId: this.teamId, fromDate: this.startDate, toDate: this.endDate })
            }).finally(() => {
                this.isAdd[index] = false
                this.submitLoading = false
            })
        },

        update (index) {
            console.log('this.items[index]', this.items[index])
            this.submitLoading = true
            const data = {
                materialId: this.materialIds[index],
                amount: +this.quantity[index],
                notes: this.notes[index],
                workloadId: this.workloadId[index],
            }
            this.$store.dispatch('teams/updateTeamMaterial', { 
                teamId: this.teamId, 
                specialtyId: this.specialtyIds[index],
                id: this.items[index].id,
                data: data,
                date: moment(this.startDate).format('YYYY-MM-DD'),
            }).then(() => {
                this.getTeamById()
                // this.$store.dispatch('materials/fetchMaterialsTeams', { teamId: this.teamId, fromDate: this.startDate, toDate: this.endDate })
            }).finally(() => {
                this.submitLoading = false
            })
        },

        getTeamPlannedTransactionForMonth() {
            return this.$store.dispatch('materialTransactions/getTeamPlannedTransactionForMonth', { date: moment(this.startDate).format('YYYY-MM-DD'), teamId: this.teamId })
        },

        async submit () {
            // تفعيل جميع مؤشرات التحميل في بداية العملية
            this.submitLoading = true

            this.dialog = true
            try {
                // الخطوة 1: جلب وحذف المعاملات الأولية غير المكتملة
                const { data: initialTransactions } = await this.getTeamPlannedTransactionForMonth()
                this.transactionEmployeeTeam = initialTransactions

                const deletePromises = initialTransactions
                    .filter(transaction => transaction.isDone === false)
                    .map(transaction => this.deleteDialogRow(transaction.id))
                
                if (deletePromises.length > 0) {
                    await Promise.all(deletePromises)
                }

                // الخطوة 2: إنشاء معاملات جديدة بشكل متوازٍ
                const teamPlanData = await this.$store.dispatch('teams/getCustomerVisitsForThisTeam', { id: this.teamId })
                this.teamPlan = teamPlanData

                const createPromises = []
                for (const plan of this.teamPlan) {
                    const itemsSameSameSpeAndClass = this.items.filter(c => c.specialtyId === plan.specialtyId && plan.customers.find(r => r.workloadId === c.workloadId))
                    for (const item of itemsSameSameSpeAndClass) {
                        const customer = plan.customers.find(r => r.workloadId === item.workloadId)
                        if (customer) {
                            createPromises.push(this.$store.dispatch('materialTransactions/createTeamPlanned', {
                                accountId: plan.accountId,
                                inAmount: +item.amount * +customer.customersCount,
                                materialId: item.materialId,
                                date: moment(this.startDate).format('YYYY-MM-DD'),
                            }))
                        }
                    }
                }

                if (createPromises.length > 0) {
                    await Promise.all(createPromises)
                }

                // الخطوة 3: جلب وحذف المعاملات النهائية بناءً على الحالة الجديدة
                const { data: updatedTransactions } = await this.getTeamPlannedTransactionForMonth()

                if (this.transactionEmployeeTeam.length) {
                    const doneTransactions = this.transactionEmployeeTeam.filter(c => c.isDone === true)
                    const finalDeletePromises = []
                    for (const doneTransaction of doneTransactions) {
                        const transactionToDelete = updatedTransactions.find(c =>
                            c.materialId === doneTransaction.materialId &&
                            c.accountId === doneTransaction.accountId &&
                            c.in === doneTransaction.in && c.isDone === false)
                        if (transactionToDelete) {
                            finalDeletePromises.push(this.deleteDialogRow(transactionToDelete.id))
                        }
                    }
                    if (finalDeletePromises.length > 0) {
                        await Promise.all(finalDeletePromises)
                        this.submitLoading = false
                    }
                } else {
                    this.transactionEmployeeTeam = updatedTransactions
                }
            } catch (error) {
                // في حال حدوث أي خطأ، يتم تسجيله هنا
                console.error('An error occurred during submission:', error)
            }
            this.submitLoading = false
        },

        // submit () {
        //     this.loading = true
        //     this.submitLoading = true
        //     this.loadingTest = true
        //     this.getTeamPlannedTransactionForMonth().then(({ data }) => {
        //         this.transactionEmployeeTeam = data
        //         if (data.length) {
        //             for (let k = 0; k < this.transactionEmployeeTeam.length; k++) {
        //                 if (this.transactionEmployeeTeam[k].isDone === false) {
        //                     this.submitLoading = true  
        //                     this.deleteDialogRow(this.transactionEmployeeTeam[k].id)
        //                 }
        //             }
        //         }  
        //         this.submitLoading = true  
        //         this.$store.dispatch('teams/getCustomerVisitsForThisTeam', { id: this.teamId }).then((data) => {
        //             this.teamPlan = data
                    
        //             for (let i = 0; i < this.teamPlan.length; i++) {
        //                 const itemsSameSameSpeAndClass = this.items.filter(c => c.specialtyId === this.teamPlan[i].specialtyId && this.teamPlan[i].customers.find(r => r.workloadId === c.workloadId))
        //                 for (let j = 0; j < itemsSameSameSpeAndClass.length; j++) {      
        //                     this.submitLoading = true
        //                     this.$store.dispatch('materialTransactions/createTeamPlanned', {
        //                         accountId: this.teamPlan[i].accountId,
        //                         inAmount:  +itemsSameSameSpeAndClass[j].amount * +this.teamPlan[i].customers.find(r => r.workloadId === itemsSameSameSpeAndClass[j].workloadId).customersCount,
        //                         materialId: itemsSameSameSpeAndClass[j].materialId, 
        //                         date: moment(this.startDate).format('YYYY-MM-DD'),
        //                         // description
        //                     }).then(() => {
        //                         this.submitLoading = true
        //                         this.getTeamPlannedTransactionForMonth().then(({ data }) => {
        //                             // const newTransac
        //                             if (this.transactionEmployeeTeam.length) {
        //                                 for (let r = 0; r < this.transactionEmployeeTeam.filter(c => c.isDone === true).length; r++) {
        //                                     if (
        //                                         data.find(c => 
        //                                         c.materialId === this.transactionEmployeeTeam[r].materialId &&
        //                                         c.accountId === this.transactionEmployeeTeam[r].accountId &&
        //                                         c.in === this.transactionEmployeeTeam[r].in && c.isDone === false)
        //                                     ) {
        //                                         this.submitLoading = true
        //                                         this.deleteDialogRow(data.find(c => 
        //                                         c.materialId === this.transactionEmployeeTeam[r].materialId &&
        //                                         c.accountId === this.transactionEmployeeTeam[r].accountId &&
        //                                         c.in === this.transactionEmployeeTeam[r].in && c.isDone === false).id)
        //                                     }
        //                                 }
        //                             } else {
        //                                 this.transactionEmployeeTeam = data
        //                                 this.submitLoading = false
        //                                 this.loading = false
        //                                 this.loadingTest = false
        //                             }
        //                         })
        //                     }).catch(() => {
        //                         this.submitLoading = false
        //                         this.loading = false
        //                         this.loadingTest = false
        //                     })
        //                 }
        //             }
        //             this.loadingTest = false
        //         }).catch(() => {
        //             this.loading = false
        //         })
        //         this.dialog = true
        //     }).catch(() => {
        //         this.loading = false
        //         this.submitLoading = false
        //         this.loading = false
        //     }).catch(() => {
        //         this.loading = false
        //         this.submitLoading = false
        //         this.loadingTest = false
        //     })
        // },

        deleteDialogRow (id) {
            this.loading = true
            return this.$store.dispatch('materialTransactions/deleteTeamPlanned', { id: id }).then(() => {
                this.submitLoading = true
                this.getTeamPlannedTransactionForMonth().then(({ data }) => {
                   this.transactionEmployeeTeam = []
                   this.transactionEmployeeTeam = data
                   this.loading = false
                }).catch(() => {
                    this.loading = false
                }).finally(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.loadingTest = false
            })
        },

        saveDate (date) {
            this.$refs.dateInputTable.save(date)
        },

        editItem() {
            this.transactionEmployeeTeam[this.editRowIndex].description = this.tableInputs.description;
            this.transactionEmployeeTeam[this.editRowIndex].date = this.tableInputs.date;
            this.transactionEmployeeTeam[this.editRowIndex].in = this.tableInputs.in;
            this.transactionEmployeeTeam[this.editRowIndex].accountId = this.tableInputs.accountId
            this.transactionEmployeeTeam[this.editRowIndex].materialId = this.tableInputs.materialId

            this.loading = true
            this.$store.dispatch('materialTransactions/updateTeamPlanned', {
                accountId: this.tableInputs.accountId,
                inAmount: this.tableInputs.in,
                materialId: this.tableInputs.materialId,
                date: this.tableInputs.date,
                description: this.transactionEmployeeTeam[this.editRowIndex].description,
                id: this.myItem.id
            }).then(() => {
                this.getTeamPlannedTransactionForMonth().then(({ data }) => {
                    this.transactionEmployeeTeam = data
                })
            }).finally(() => {
                this.myItem = null
                this.loading = false
                this.myItem = null
                this.editRowIndex = null;
                this.isEdit = false;
                this.$refs.table.resetEdit()
            })
        },

        transactionAndPosted (id) {
            this.loading = true
            this.$store.dispatch('materialTransactions/executeTeamPlannedTransaction', { id: id }).then(({ data }) => {
                this.getTeamPlannedTransactionForMonth().then(({ data }) => {
                    this.transactionEmployeeTeam = []
                    this.transactionEmployeeTeam = data
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
            })
        },

        nextMonth () {
            this.startDate = moment(this.startDate).add(1, 'month').format('YYYY-MM')
		},
		prevMonth () {
            this.startDate = moment(this.startDate).subtract(1, 'month').format('YYYY-MM')
		},

    },

    created() {
        this.loading = true
        Promise.all([
            !this.myMaterials.length ? this.$store.dispatch('materials/fetchMyMaterial', { 
				employeeId: this.staff.find(c => c.accountId === this.tableInputs.accountId)?.id,
				withPrices: false
			}) : null,

            !this.teams.length ? this.$store.dispatch('teams/fetchAll') : null,
            !this.specialties.length ? this.$store.dispatch('specialties/fetchAll') : null,
            
            !this.materials.length ? this.$store.dispatch('materials/fetchAll', true) : null,

            !this.staff.length ? this.$store.dispatch('accounts/fetchAllBrief', { type: 0, includeAddress: true, regionIds: [] }) : null,
            
            !this.classification.length ? this.$store.dispatch('workload/fetchAll') : null,
        ]).finally(() => {
            this.loading = false
        })
    }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
.bgPrimaryLight {
    background-color: #A5D6A7;
}
</style>
